import { render, staticRenderFns } from "./NewProposalForm.vue?vue&type=template&id=7b5841fb&scoped=true&"
import script from "./NewProposalForm.vue?vue&type=script&lang=js&"
export * from "./NewProposalForm.vue?vue&type=script&lang=js&"
import style0 from "./NewProposalForm.vue?vue&type=style&index=0&id=7b5841fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5841fb",
  null
  
)

export default component.exports